import React, { useState, useEffect } from "react";
import "../Component/AddCourtPopup.css"; // reuse popup styles
import { API_BASE_URL } from "../config";

export default function NewCase({ onAddCase }) {
  const [showPopup, setShowPopup] = useState(false);
  const [courts, setCourts] = useState([]); // list of courts
  const [advocates, setAdvocate] = useState([]); // list of Advocate
  const [chamber, setChamber] = useState([]); // list of Advocate 
  const [party, setParty] = useState([]); // list of party
  const [casestatus, setCaseStatus] = useState([]); // list of party

  const [newCase, setNewCase] = useState({
    CaseNumber: "",
    Title: "",
    AdvocateId: "",
    CourtId: "",
    ChamberId: "",
    PetitionerId: "",
    Respondent: "",
    CaseStatusId: "",
    FilingDate: null,
    HearingDate: null,
    NextHearingDate: null,
    Remarks: ""
  });

  useEffect(() => {
    if (showPopup) {
      // Fetch courts when popup opens
      const fetchCourts = async () => {
        try {
          const token = localStorage.getItem("token");
          const res = await fetch(`${API_BASE_URL}/api/CourtMaster/GetCourt`, {
            headers: { Authorization: `Bearer ${token}` },
          });

          if (res.ok) {
            const data = await res.json();
            setCourts(data);
          } else {
            console.error("Failed to fetch courts");
          }
        } catch (err) {
          console.error("Error fetching courts:", err);
        }
      };
      // Fetch advocate when popup opens
      const fetchAdvocate = async () => {
        try {
          const token = localStorage.getItem("token");
          const res = await fetch(`${API_BASE_URL}/api/AdvocateMaster/GetAdvocate`, {
            headers: { Authorization: `Bearer ${token}` },
          });

          if (res.ok) {
            const data = await res.json();
            setAdvocate(data);
          } else {
            console.error("Failed to fetch advocate");
          }
        } catch (err) {
          console.error("Error fetching advocate:", err);
        }
      };
      // Fetch chamber when popup opens
      const fetchChamber = async () => {
        try {
          const token = localStorage.getItem("token");
          const res = await fetch(`${API_BASE_URL}/api/ChamberMaster/GetChember`, {
            headers: { Authorization: `Bearer ${token}` },
          });

          if (res.ok) {
            const data = await res.json();
            setChamber(data);
          } else {
            console.error("Failed to fetch chamber");
          }
        } catch (err) {
          console.error("Error fetching chamber:", err);
        }
      };
      // Fetch party when popup opens
      const fetchParty = async () => {
        try {
          const token = localStorage.getItem("token");
          const res = await fetch(`${API_BASE_URL}/api/PartyMaster/GetParty`, {
            headers: { Authorization: `Bearer ${token}` },
          });

          if (res.ok) {
            const data = await res.json();
            setParty(data);
          } else {
            console.error("Failed to fetch party");
          }
        } catch (err) {
          console.error("Error fetching party:", err);
        }
      };
      // Fetch Casestatus when popup opens
      const fetchCasestatus = async () => {
        try {
          const token = localStorage.getItem("token");
          const res = await fetch(`${API_BASE_URL}/api/CaseStatus/GetCaseStatus`, {
            headers: { Authorization: `Bearer ${token}` },
          });

          if (res.ok) {
            const data = await res.json();
            setCaseStatus(data);
          } else {
            console.error("Failed to fetch status");
          }
        } catch (err) {
          console.error("Error fetching status:", err);
        }
      };
      fetchAdvocate();
      fetchCourts();    
      fetchChamber();
      fetchParty();  
      fetchCasestatus();
    }
  }, [showPopup]);

  const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const token = localStorage.getItem("token");
    const res = await fetch(`${API_BASE_URL}/api/CaseMaster/addcase`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newCase),
    });

    if (res.ok) {
      alert("Case added successfully!");
      setNewCase({
        CaseNumber: "",
        Title: "",
        AdvocateId: "",
        CourtId: "",
        ChamberId: "",
        PetitionerId: "",
        Respondent: "",
        CaseStatusId: "",
        FilingDate: null,
        HearingDate: null,
        NextHearingDate: null,
        Remarks: "",
      });
      setShowPopup(false);
    } else {
      const error = await res.text();
      alert("Failed to save case: " + error);
    }
  } catch (err) {
    console.error("Error saving case:", err);
    alert("Something went wrong while saving case.");
  }
};

  return (
    <div>
      {/* Button to open popup */}
      <button className="btn" onClick={() => setShowPopup(true)}>Add New Case</button>      

      {/* Popup */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-container">
            <h2 className="popup-title">Add Advocate</h2>
            <form onSubmit={handleSubmit} className="popup-form">
                <div className="form-grid">
              <input
                type="text"
                placeholder="Case No"
                value={newCase.CaseNumber}
                onChange={(e) =>
                  setNewCase({ ...newCase, CaseNumber: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              <input
                type="text"
                placeholder="Title"
                value={newCase.Title}
                onChange={(e) =>
                  setNewCase({ ...newCase, Title: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              {/* Dropdown for court selection */}
              <select
                value={newCase.AdvocateId}
                onChange={(e) =>
                setNewCase({ ...newCase, AdvocateId: e.target.value })
                }
                required
                className="popup-select"
                >
                <option value="">-- Select Advocate --</option>
                {advocates.map((advocate) => (
                <option key={advocate.advocateId} value={advocate.advocateId}>
                    {advocate.name}
                </option>))}
                </select>
                {/* Dropdown for court selection */}
              <select
                value={newCase.CourtId}
                onChange={(e) =>
                setNewCase({ ...newCase, CourtId: e.target.value })
                }
                required
                className="popup-select"
                >
                <option value="">-- Select Court --</option>
                {courts.map((court) => (
                <option key={court.courtId} value={court.courtId}>
                    {court.courtName} ({court.city})
                </option>))}
                </select>
                <select
                value={newCase.ChamberId}
                onChange={(e) =>
                setNewCase({ ...newCase, ChamberId: e.target.value })
                }
                required
                className="popup-select"
                >
                <option value="">-- Select chamber --</option>
                {chamber.map((chambers) => (
                <option key={chambers.chamberId} value={chambers.chamberId}>
                    {chambers.chamberName}
                </option>))}
                </select>
                <select
                value={newCase.PetitionerId}
                onChange={(e) =>
                setNewCase({ ...newCase, PetitionerId: e.target.value })
                }
                required
                className="popup-select"
                >
                <option value="">-- Select Party --</option>
                {party.map((partys) => (
                <option key={partys.partyId} value={partys.partyId}>
                    {partys.partyName}
                </option>))}
                </select>
              <input
                type="text"
                placeholder="Respondent Name"
                value={newCase.Respondent}
                onChange={(e) =>
                  setNewCase({ ...newCase, Respondent: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              <select
                value={newCase.CaseStatusId}
                onChange={(e) =>
                setNewCase({ ...newCase, CaseStatusId: e.target.value })
                }
                required
                className="popup-select"
                >
                <option value="">-- Select Status --</option>
                {casestatus.map((status) => (
                <option key={status.caseStatusId} value={status.caseStatusId}>
                    {status.statusName}
                </option>))}
                </select>
              {/* Filing Date */}
              <input
                type={newCase.FilingDate ? "date" : "text"}
                placeholder="Filing Date"
                value={newCase.FilingDate ? newCase.FilingDate.split("T")[0] : ""}
                onFocus={(e) => (e.target.type = "date")}
                onBlur={(e) => {
                if (!newCase.FilingDate) e.target.type = "text";
              }}
                onChange={(e) =>
                setNewCase({...newCase, FilingDate: e.target.value ? new Date(e.target.value).toISOString() : null
              })
              }
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              {/* Hearing Date */}
              <input
                  type={newCase.HearingDate ? "date" : "text"}
                  placeholder="Hearing Date"
                  value={newCase.HearingDate ? newCase.HearingDate.split("T")[0] : ""}
                  onFocus={(e) => (e.target.type = "date")}
                  onBlur={(e) => {
                  if (!newCase.HearingDate) e.target.type = "text";
                }}
                onChange={(e) =>
                setNewCase({...newCase, HearingDate: e.target.value ? new Date(e.target.value).toISOString() : null
                })
                }
                  style={{ display: "block", margin: "10px 0", width: "100%" }}
              />

                {/* Next Hearing Date */}
              <input
                  type={newCase.NextHearingDate ? "date" : "text"}
                  placeholder="Next Hearing Date"
                  value={newCase.NextHearingDate ? newCase.NextHearingDate.split("T")[0] : ""}
                  onFocus={(e) => (e.target.type = "date")}
                  onBlur={(e) => {
                  if (!newCase.NextHearingDate) e.target.type = "text";
                }}
                onChange={(e) =>
                setNewCase({...newCase,NextHearingDate: e.target.value ? new Date(e.target.value).toISOString(): null
                })
                }
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />

{/* Remarks */}
<input
  type="text"
  placeholder="Remark"
  value={newCase.Remarks || ""}
  onChange={(e) =>
    setNewCase({ ...newCase, Remarks: e.target.value })
  }
  required
  style={{ display: "block", margin: "10px 0", width: "100%" }}
/>

              <div className="popup-buttons">
                <button type="submit" className="btn-save">Save</button>
                <button
                  type="button"
                  className="btn-cancel"
                  onClick={() => setShowPopup(false)}
                  style={{ marginLeft: "10px" }}
                >
                  Cancel
                </button>
              </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
